import { render, staticRenderFns } from "./SellerAddresses.vue?vue&type=template&id=ae4e0874"
import script from "./SellerAddresses.vue?vue&type=script&lang=js"
export * from "./SellerAddresses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports